<script>
import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
import { Hotline } from '../../models/Hotline';
import { mapGetters } from 'vuex';
export default {
    name: 'HotlineTile',
    components: {
        ButtonIconLeft,
    },
    props: {
        hotlineData: {
            type: Hotline,
            required: true
        },
    },
    computed: {
        ...mapGetters({
            isPremium: 'isPremium'
        })
    },
};
</script>

<template>
<div class="hotline-tile" :class="{disabled:!isPremium}">
    
    <div class="right" v-if="isPremium">
        <ButtonIconLeft @onClick="$router.push({ path: '/groups/hotline',  query: { mode: 'edit' } })" buttonTitle="bearbeiten" src="edit" cssClass="btn btn-tertiary"/>
    </div>
    <div class="hotline-info">
        
        <div class="logo-and-hotline-name">
            <img src="@/assets/starface_icons_png/24/orange/teams_24@2x.png" alt="Mail Logo" width="40" height="34">
            <h2 class="hotline-name">HOTLINE</h2>
        </div>
        <hr>
        <div class="phonenumber">{{hotlineData.GUI_RUFNUMMER}}</div>
    </div>
</div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.hotline-tile {
    margin-top: 24px;
    padding: 16px;
    background-color: white;
    min-height: 244px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    .right {
        display: grid;
        display: -ms-grid;
        -ms-grid-columns: 1fr;
        .btn {
            justify-self: end;
            -ms-grid-column-align: end;
        }
    }
    .hotline-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-top: 18px;
        padding-bottom: 38px;
        hr {
            opacity: 0.5;
            width: 100%
        }
        .logo-and-hotline-name {
            display: flex;
            flex-direction: row;
            align-items: center;
            img {
                margin: 16px 16px 0 0;
            }
            .hotline-name {
                margin-top: 8px;
            }
        }
        .phonenumber {
            padding-bottom: 8px;
        }
        .voice-mailbox-number {
            font-size: 18px
        }
    }
    .hotline-active-status {
        font-size: 16px;
    }
    &.disabled {
        opacity: .4;
    }
}
</style>
